import React from 'react'
import createReactClass from 'create-react-class'
import ViewURLModalPanel from './modal-panels/view-url-modal-panel'

export default createReactClass({
  getInitialState () {
    return {
      showModal: false,
    }
  },
  onViewURLClick () {
    this.setState({
      showModal: true,
    })
  },
  closeModal () {
    this.setState({
      showModal: false,
    })
  },
  renderModalPanel () {
    if (this.state.showModal) {
      return (
        <ViewURLModalPanel {...this.props} closeModal={this.closeModal}/>
      )
    }
    return false
  },
  render () {
    return (
      <span>
        <button type='button' onClick={this.onViewURLClick} className="cs-grey-button" disabled={this.props.loader}>View URL</button>
        {this.renderModalPanel()}
      </span>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/view-url-panel.js